module.exports = __webpack_public_path__ + "static/media/call_medic.fba4ea84.svg";